import { gql } from '__generated__/gql'

export interface CandidateInterviewBucket {
    candidateInterviewLink: string | null
}

export const CandidateInterviewBucketQuery = gql(/* GraphQL */ `
    query CandidateInterviewBucket {
        candidateInterviewBucket {
            id
            candidateInterviewLink
        }
    }
`)

export const CandidateMeQuery = gql(/* GraphQL */ `
    query CandidateMeQuery {
        candidateMe {
            id
            linkedinUrl
            user {
                id
                firstName
                lastName
                nickname
                email
                phone
                isActive
                roles
                profileImageKey
            }
            candidateIntakes {
                id
                intake {
                    id
                    intakePart {
                        id
                        displayName
                        internalName
                        order
                    }
                }
                completionDate
            }
        }
    }
`)
export const CreateCandidateSchedule = gql(/* GraphQL */ `
    mutation CreateCandidateSchedule($input: CandidateScheduleInput!) {
        createCandidateSchedule(input: $input) {
            id
            candidateId
            eventUrl
            inviteeUrl
        }
    }
`)

export const GetCandidateSchedule = gql(/* GraphQL */ `
    query GetCandidateSchedule($id: String!) {
        candidateSchedule(id: $id) {
            id
            candidateId
            eventUrl
            inviteeUrl
            createdAt
            updatedAt
        }
    }
`)
export const GetEventDetails = gql(/* GraphQL */ `
    query GetEventDetails($eventId: String!) {
        callScheduledEventsAPI(eventId: $eventId) {
            uri
            name
            start_time
            end_time
            status
            event_memberships {
                user_name
            }
            location {
                join_url
            }
        }
    }
`)

export const CallScheduledInviteeAPI = gql(`
    query CallScheduledInviteeAPI($inviteeId: String!) {
        callScheduledInviteeAPI(inviteeId: $inviteeId) {
            reschedule_url
            cancel_url
        }
    }
`)

export const UpdateCandidateBioMutation = gql(`
    mutation UpdateCandidateBio(
        $id: ID!
        $phone: String!
        $linkedinUrl: String
    ) {
        updateCandidateBio(id: $id, phone: $phone, linkedinUrl: $linkedinUrl) {
            id
            linkedinUrl
            user {
                id
                firstName
                lastName
                nickname
                email
                phone
                isActive
                roles
                profileImageKey
            }
        }
    }
`)
